"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var bluebird = require("bluebird");
var sha1 = require("js-sha1");
var zlib = require('zlib');
bluebird.promisifyAll(zlib);
var GitObject = /** @class */ (function () {
    function GitObject() {
    }
    /** The SHA1 hash of this git object */
    GitObject.prototype.getSha1 = function () {
        return sha1(this.contents);
    };
    /**
     * Serializes this object into a Buffer that can
     * be written to the file system
     */
    GitObject.prototype.serialize = function () {
        return __awaiter(this, void 0, void 0, function () {
            var serialized;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        serialized = [
                            this.type,
                            ' ',
                            this.getSize(),
                            '\u0000',
                            this.contents,
                        ].join('');
                        return [4 /*yield*/, zlib.deflateAsync(serialized)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Deserializes file data into this object
     * @param fileContents The contents of the file
     * from the file system
     */
    GitObject.prototype.deserialize = function (fileBuffer) {
        return __awaiter(this, void 0, void 0, function () {
            var deserializePattern, fileContents, match, size;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        deserializePattern = new RegExp("^" + this.type + " ([0-9]+)\0(.*)$", 's');
                        return [4 /*yield*/, zlib.unzipAsync(fileBuffer)];
                    case 1:
                        fileContents = (_a.sent()).toString();
                        match = deserializePattern.exec(fileContents);
                        size = parseInt(match[1], 10);
                        this.contents = match[2];
                        if (this.getSize() !== size) {
                            throw new Error("Malformed object: object stated it was of size " + size + ", " +
                                ("but it really is of size " + this.getSize()));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /** The size of this git object */
    GitObject.prototype.getSize = function () {
        return this.contents.length;
    };
    return GitObject;
}());
exports.GitObject = GitObject;
